import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGiftBox"><Path d="M21.5 4.5H2.5V9.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 9.5V19.5H20.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 4.5V19.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGiftBox;
